module.exports = "<div class=events-list ng-show=\"day.events.length > 0\"><a ng-repeat=\"event in day.events | orderBy:'startsAt' track by event.$id\" href=javascript:; ng-click=\"vm.onEventClick({calendarEvent: event})\" class=\"pull-left event\" ng-class=\"'event-' + event.type + ' ' + event.cssClass\" ng-mouseenter=\"vm.highlightEvent(event, true)\" ng-mouseleave=\"vm.highlightEvent(event, false)\" tooltip-append-to-body=true tooltip-html-unsafe=\"{{ (event.startsAt | calendarDate:'time':true) + ' - ' + event.title }}\" mwl-draggable=\"event.draggable === true\" drop-data=\"{event: event}\"></a></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/calendarMonthEventsList.html
 ** module id = 7
 ** module chunks = 0
 **/